import React from 'react';

function Skills() {
    const skillCategories = [
        {
            title: "Programming",
            icon: "bi-terminal-fill",
            skills: ["Python", "JavaScript", "PHP", "Dart"]
        },
        {
            title: "Frameworks",
            icon: "bi-layers-fill",
            skills: ["Flutter", "React", "Laravel", "Node.js"]
        },
        {
            title: "Cloud & Data",
            icon: "bi-cloud-check-fill",
            skills: ["Firebase", "MySQL", "PostgreSQL", "Express.js"]
        },
        {
            title: "Engineering",
            icon: "bi-cpu-fill",
            skills: ["Git", "Networking", "IT Support", "Figma"]
        }
    ];

    return (
        <section id="skills" className="py-32 bg-black relative overflow-hidden">
            {/* Background Glow */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-green-500/5 rounded-full blur-[120px]"></div>

            <div className="max-w-7xl mx-auto px-6 lg:px-12 relative z-10">
                <div className="flex flex-col md:flex-row justify-between items-end gap-10 mb-20 animate-fade-in-up">
                    <div className="space-y-4">
                        <h2 className="text-green-500 font-black tracking-widest text-sm uppercase">Capabilities</h2>
                        <h3 className="text-5xl md:text-7xl font-black text-white leading-none">TECH <br /><span className="text-transparent bg-clip-text bg-gradient-to-r from-gray-400 to-gray-600 uppercase">Stack.</span></h3>
                    </div>
                    <p className="max-w-md text-xl text-gray-400 font-medium">
                        A curated toolkit of industry-leading technologies I leverage to build scalable, high-performance digital products.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                    {skillCategories.map((category, index) => (
                        <div
                            key={index}
                            className="glass-card p-10 rounded-[2.5rem] group hover:border-green-500/30 transition-all duration-500 overflow-hidden relative"
                        >
                            <div className="absolute top-0 right-0 p-8 text-neutral-800 text-6xl group-hover:text-green-500/10 transition-colors duration-500">
                                <i className={`bi ${category.icon}`}></i>
                            </div>

                            <div className="relative z-10 space-y-10">
                                <div className="w-16 h-16 bg-white/5 rounded-2xl flex items-center justify-center text-3xl text-white border border-white/10 group-hover:bg-green-500 group-hover:text-black transition-all duration-500">
                                    <i className={`bi ${category.icon}`}></i>
                                </div>

                                <h3 className="text-2xl font-black text-white uppercase tracking-tighter">
                                    {category.title}
                                </h3>

                                <ul className="space-y-4">
                                    {category.skills.map((skill, skillIndex) => (
                                        <li key={skillIndex} className="flex items-center gap-3 text-lg font-bold text-gray-400 group-hover:text-white transition-colors duration-300">
                                            <div className="w-1.5 h-1.5 rounded-full bg-green-500"></div>
                                            {skill}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Skills;
